module.exports = __webpack_public_path__ + "static/media/browser.34a666ae.png";